// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3W9Pq","vLegacy":"SelectSecondary_vLegacy__IDwKb","error":"SelectSecondary_error__2swv9","disabled":"SelectSecondary_disabled__3ycml"};